import * as ko from "knockout";

export interface IClientCredentialField {
    name: string
    label: string
    type: 'string' | 'password'
    required: boolean
}

export class CredentialFieldVm {
    readonly value = ko.observable('');
    readonly secretMaskText = ko.observable('');
    readonly useSecretFingerprintMask = ko.observable(false);
    readonly secretRevealPlain = ko.observable(false);

    constructor(readonly field: IClientCredentialField) {
    }

    clearSecretMask() {
        this.secretMaskText('');
        this.useSecretFingerprintMask(false);
        this.secretRevealPlain(false);
    }

    beginWithFingerprint(fingerprint: string) {
        if (fingerprint) {
            this.secretMaskText(fingerprint);
            this.useSecretFingerprintMask(true);
        } else {
            this.clearSecretMask();
        }
        this.value('');
        this.secretRevealPlain(false);
    }

    private enterSecretEditMode(initialValue = '') {
        this.useSecretFingerprintMask(false);
        this.secretMaskText('');
        this.value(initialValue);
        this.secretRevealPlain(false);
        queueMicrotask(() => {
            const el = document.querySelector(
                '.comp-sync-credentials-details input.client-credential-secret-input',
            );
            if (el instanceof HTMLInputElement) {
                el.focus();
                const len = el.value.length;
                el.setSelectionRange(len, len);
            }
        });
    }

    effectiveNonMaskInputType = ko.pureComputed((): 'text' | 'password' => {
        if (this.field.type !== 'password') {
            return 'text';
        }
        return this.secretRevealPlain() ? 'text' : 'password';
    });

    onFingerprintMaskFocus = (_: unknown, e: FocusEvent) => {
        if (!this.useSecretFingerprintMask()) {
            return;
        }
        const el = e.target as HTMLInputElement;
        requestAnimationFrame(() => el?.select?.());
    };

    onFingerprintMaskKeyDown = (_: unknown, e: KeyboardEvent) => {
        if (!this.useSecretFingerprintMask()) {
            return true;
        }
        if (e.key === 'Tab' || e.key === 'Escape') {
            return true;
        }
        if (['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Home', 'End'].includes(e.key)) {
            return true;
        }
        if (e.ctrlKey || e.metaKey) {
            if (['a', 'c', 'A', 'C'].includes(e.key)) {
                return true;
            }
        }
        e.preventDefault();
        if (e.key === 'Backspace' || e.key === 'Delete') {
            this.enterSecretEditMode('');
        } else if (e.key.length === 1) {
            this.enterSecretEditMode(e.key);
        } else {
            this.enterSecretEditMode('');
        }
        return false;
    };

    onFingerprintMaskPaste = (_: unknown, e: ClipboardEvent) => {
        if (!this.useSecretFingerprintMask()) {
            return true;
        }
        e.preventDefault();
        const text = e.clipboardData?.getData('text') ?? '';
        this.enterSecretEditMode(text);
        return false;
    };
}
